import { FlexBuffer, Connection, makePromise, connectToServer } from 'outpost';
import { SERIALIZABLE_ASSETS } from '../network-constants.ts';
import { ClientMessageKind, ClientMessageParams, CreateGameParams, ServerMessageKind, SyncGameParams } from '../network-types.ts';
import { BoardLocalData } from './board-local-data.ts';
import { BoardInitParams } from './client-connection-types.ts';

export type ClientConnectionParams = {
    label: string;
};

export class ClientConnection {
    private label: string;
    private buffer: FlexBuffer = new FlexBuffer();
    private serverConnection!: Connection;
    private onConnectedToServer = makePromise<ClientConnection>();
    private onConnectedToGame = makePromise<BoardInitParams | null>();
    localData: BoardLocalData | null = null;

    private constructor(params: ClientConnectionParams) {
        this.label = params.label;
    }

    static async start(params: ClientConnectionParams): Promise<ClientConnection> {
        let connection = new ClientConnection(params);

        return await connection.start();
    }

    private async start(): Promise<ClientConnection> {
        this.serverConnection = connectToServer({
            onConnect: (connection) => this.onConnect(connection),
            onDisconnect: (connection) => this.onDisconnect(connection),
            onMessage: (connection, data) => this.onServerMessage(connection, data),
        });

        return this.onConnectedToServer.promise;
    }

    private onConnect(connection: Connection) {
        this.onConnectedToServer.resolve(this);
    }

    private onDisconnect(connection: Connection) {

    }

    private onServerMessage(connection: Connection, arrayBuffer: ArrayBuffer) {
        let buffer = new FlexBuffer(arrayBuffer);
        let kind = buffer.readString() as ServerMessageKind;
        let params = buffer.readAny(SERIALIZABLE_ASSETS);

        if (kind === 'joinGameResponse') {
            this.onJoinGameResponse(params);
        } else if (kind === 'syncGame') {
            this.onSyncGame(params);
        }
    }

    private onJoinGameResponse(params: CreateGameParams) {
        this.onConnectedToGame.resolve({
            board: params.board,
            projectHash: params.projectHash,
            spreadsheetId: params.spreadsheetId,
        });
    }

    private onSyncGame(params: SyncGameParams) {
        console.log(params.board);
        if (this.localData) {
            this.localData.board = params.board;
            this.localData.forceRefresh();
        }
    }

    private sendMessageToServer<K extends ClientMessageKind>(kind: K, params: ClientMessageParams[K]) {
        // console.log(`${this.label}: send to server ${kind}`);
        this.buffer.reset();
        this.buffer.writeString(kind);
        this.buffer.writeAny(params, SERIALIZABLE_ASSETS);
        this.serverConnection.sendMessage(this.buffer);
    }

    createGame(localData: BoardLocalData): string {
        let roomId = crypto.randomUUID();

        this.sendMessageToServer('createGame', {
            roomId,
            board: localData.board,
            spreadsheetId: localData.project.spreadsheetId,
            projectHash: localData.project.getHash(),
        });

        console.log(localData.board);

        this.localData = localData;

        return roomId;
    }

    joinGame(roomId: string) {
        this.sendMessageToServer('joinGame', { roomId });
    }

        sendBoardState() {
        this.sendMessageToServer('syncGame', {
            board: this.localData!.board,
        });
    }

    async whenConnectedToGame(): Promise<BoardInitParams | null> {
        return this.onConnectedToGame.promise;
    }
}